export const CLASH_DOWNLOAD_URL = "https://github.com/clash-verge-rev/clash-verge-rev/releases/latest";
export function clashImportUrl(subscriptionUrl: string): string {
  const url = new URL(subscriptionUrl);
  if (url.protocol !== "https:") throw new Error("订阅必须使用 HTTPS。");
  return `clash://install-config?url=${encodeURIComponent(url.toString())}`;
}
